<div class="guests-capture">
  <div class="pax-display" (click)="onDisplay($event)">
    <div class="pax">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-fill" viewBox="0 0 16 16">
        <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6"/>
      </svg>
    </div>
    <div class="pax adults"><span class="pax-count">{{adults}}</span> adults</div>
    <div class="pax children"><span class="pax-count">{{children}}</span> children</div>
  </div>
  <div class="pax-capture" *ngIf="showCapture" appClickOutside (clickOutside)="closeDropdown()">
    <div class="d-flex justify-content-between">
      <div>
        <span>Adults</span>
      </div>
      <div class="controls">
          <button type="button" class="btn btn-outline-primary" [disabled]="adults <= 1" (click)="onQuantity('adult', operation.MINUS)">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-dash" viewBox="0 0 16 16">
              <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8"/>
            </svg>  
          </button>

          <div class="quantity">{{adults}}</div>
          <button type="button" class="btn btn-outline-primary" (click)="onQuantity('adult', operation.PLUS)">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus" viewBox="0 0 16 16">
              <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"/>
            </svg>
          </button>
      </div>
    </div>
    <div class="d-flex justify-content-between children-pax">
      <div>
        <span>Children</span>
      </div>
      <div class="controls">
          <button type="button" class="btn btn-outline-primary" (click)="onQuantity('children', operation.MINUS)">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-dash" viewBox="0 0 16 16">
              <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8"/>
            </svg>  
          </button>
          <div class="quantity">{{children}}</div>
          <button type="button" class="btn btn-outline-primary" (click)="onQuantity('children', operation.PLUS)">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus" viewBox="0 0 16 16">
              <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"/>
            </svg>
          </button>

      </div>
    </div>
  </div>
</div>